<template>
  <div class="hello">
    <div class="head-link-container flex-center">
      <div v-if="back == 'disable'"></div>
      <!-- <div
        v-else-if="back"
        @click="$router.push(back)"
        class="bt-home flex-mid"
      > -->
      <div
        v-else-if="back == 'back'"
        @click="$router.go(-1)"
        class="bt-home flex-mid"
      >
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.95079 0.302444C8.35364 0.705703 8.35364 1.35951 7.95079 1.76277L2.49082 7.22826L7.95079 12.6938C8.35364 13.097 8.35364 13.7508 7.95079 14.1541C7.54794 14.5573 6.89479 14.5573 6.49194 14.1541L0.302541 7.95843C-0.100311 7.55517 -0.100311 6.90136 0.302541 6.4981L6.49194 0.302444C6.89479 -0.100815 7.54794 -0.100815 7.95079 0.302444Z"
            fill="#037968"
          />
        </svg>
      </div>
      <div
        v-else-if="back"
        @click="$router.push(back)"
        class="bt-home flex-mid"
      >
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.95079 0.302444C8.35364 0.705703 8.35364 1.35951 7.95079 1.76277L2.49082 7.22826L7.95079 12.6938C8.35364 13.097 8.35364 13.7508 7.95079 14.1541C7.54794 14.5573 6.89479 14.5573 6.49194 14.1541L0.302541 7.95843C-0.100311 7.55517 -0.100311 6.90136 0.302541 6.4981L6.49194 0.302444C6.89479 -0.100815 7.54794 -0.100815 7.95079 0.302444Z"
            fill="#037968"
          />
        </svg>
      </div>
      <div v-else @click="redirect('?mainapp')" class="bt-home flex-mid">
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.2969 10.5094L13.7135 3.874C13.3051 3.51661 12.6952 3.51661 12.2868 3.874L4.70345 10.5094C4.46835 10.7151 4.3335 11.0123 4.3335 11.3247V20.5831C4.3335 21.1814 4.81852 21.6665 5.41683 21.6665H9.75016C10.3485 21.6665 10.8335 21.1814 10.8335 20.5831V16.2498C10.8335 15.6515 11.3185 15.1665 11.9168 15.1665H14.0835C14.6818 15.1665 15.1668 15.6515 15.1668 16.2498V20.5831C15.1668 21.1814 15.6519 21.6665 16.2502 21.6665H20.5835C21.1818 21.6665 21.6668 21.1814 21.6668 20.5831V11.3247C21.6668 11.0123 21.532 10.7151 21.2969 10.5094Z"
            stroke="#037968"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="title center">{{ title }}</div>
      <div v-if="menu == 'disable'"></div>
      <div v-else class="flex-center">
        <!-- cart close 7 Feb 2023 -->
        <!-- <div
          v-if="channel == 'supperapp'"
          class="ml-auto cursor-pointer"
          @click="redirect('/cart')"
        >
          <svg
            width="27"
            height="25"
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.31485 4.16648L6.25967 16.8078C6.27382 16.9122 6.30342 17.0116 6.3461 17.1037C6.47456 17.3811 6.72147 17.5925 7.02191 17.6728C7.11369 17.6975 7.20988 17.7098 7.30827 17.7081H18.7502C19.2102 17.7081 19.6157 17.4064 19.7479 16.9658L22.8729 6.54914C22.9675 6.23375 22.9074 5.89219 22.7109 5.62801C22.5143 5.36384 22.2044 5.20815 21.8752 5.20815H6.58295L6.24035 2.98127C6.22752 2.88816 6.20238 2.79898 6.16663 2.71542C6.10174 2.56326 6.00238 2.43145 5.87964 2.32814C5.76576 2.23211 5.631 2.16005 5.48315 2.11974C5.3901 2.09426 5.29246 2.08149 5.19255 2.08315H3.12516C2.54987 2.08315 2.0835 2.54952 2.0835 3.12482C2.0835 3.70011 2.54987 4.16648 3.12516 4.16648H4.31485ZM8.18551 15.6248L6.90346 7.29148H20.4751L17.9751 15.6248H8.18551Z"
              fill="#037968"
            />
            <path
              d="M10.4168 20.8332C10.4168 21.9837 9.48409 22.9165 8.3335 22.9165C7.1829 22.9165 6.25016 21.9837 6.25016 20.8332C6.25016 19.6826 7.1829 18.7498 8.3335 18.7498C9.48409 18.7498 10.4168 19.6826 10.4168 20.8332Z"
              fill="#037968"
            />
            <path
              d="M19.7918 20.8332C19.7918 21.9837 18.8591 22.9165 17.7085 22.9165C16.5579 22.9165 15.6252 21.9837 15.6252 20.8332C15.6252 19.6826 16.5579 18.7498 17.7085 18.7498C18.8591 18.7498 19.7918 19.6826 19.7918 20.8332Z"
              fill="#037968"
            />
            <circle
              v-if="showCartNoti"
              cx="22.1153"
              cy="5.76912"
              r="4.00769"
              fill="#F77878"
              stroke="#037968"
              stroke-width="1.6"
            />
          </svg>
        </div> -->

        <!-- <div v-if="channel=='supperapp'" class="ml-12 cursor-pointer" @click="redirect('?noti')">
          <svg
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.54315 1.31053C7.85682 0.541966 8.61478 0 9.5 0C10.3852 0 11.1432 0.541966 11.4569 1.31053C14.588 2.16375 16.8889 5.01458 16.8889 8.4V13.3321L18.8227 16.2176C19.0387 16.5398 19.0588 16.954 18.8751 17.2955C18.6914 17.6369 18.3337 17.85 17.9444 17.85H13.157C12.9009 19.631 11.3612 21 9.5 21C7.63881 21 6.09906 19.631 5.84297 17.85H1.05556C0.666273 17.85 0.308587 17.6369 0.124901 17.2955C-0.0587861 16.954 -0.038654 16.5398 0.177282 16.2176L2.11111 13.3321V8.4C2.11111 5.01458 4.41204 2.16375 7.54315 1.31053ZM8.00676 17.85C8.22412 18.4617 8.81061 18.9 9.5 18.9C10.1894 18.9 10.7759 18.4617 10.9932 17.85H8.00676ZM9.5 3.15C6.58516 3.15 4.22222 5.5005 4.22222 8.4V13.65C4.22222 13.8573 4.16054 14.06 4.04494 14.2324L3.02788 15.75H15.9721L14.9551 14.2324C14.8395 14.06 14.7778 13.8573 14.7778 13.65V8.4C14.7778 5.5005 12.4148 3.15 9.5 3.15Z"
              fill="#037968"
            />

            <circle
              cx="16.1153"
              cy="4.76912"
              r="4.00769"
              fill="#F77878"
              stroke="#037968"
              stroke-width="1.6"
            />
          </svg>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";

export default defineComponent({
  name: "HelloWorld",
  props: {
    title: String,
    back: String,
    menu: String,
  },
  data() {
    return {
      channel: null,
      showCartNoti: false,
      accessToken: null,
      lang: "th",
    };
  },
  mounted() {
    this.channel = this.$cookies.get("channel");
    if (this.channel == "supperapp") {
      this.accessToken = this.$cookies.get("access_token");
      this.lang = this.$cookies.get("lang");
      this.getPending();
    }
  },
  methods: {
    redirect(redirect) {
      window.location.href = redirect;
    },
    getPending() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/purchase/get/pending-payment",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          this.showCartNoti = res.data.length > 0;
        });
    },
  },
});
</script>

<style lang="scss" scoped>
.head-link-container {
  min-height: 3.5rem;
  padding: 1rem 0;
  display: grid;
  grid-template-columns: 15% auto 15%;
  @media only screen and (max-width: 514px) {
    padding: 1.6rem 0;
  }
  .bt-home {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 3.5rem;
    background: #fafafa;
    transition: 0.3s;
    cursor: pointer;
    // filter: drop-shadow(3px 4px 7px rgba(165, 165, 165, 0.25));
    box-shadow: 3px 4px 7px 0px #a5a5a540;

    &:hover {
      background-color: #efefef;
      // filter: drop-shadow(1px 1px 3px rgba(165, 165, 165, 0.45));
      box-shadow: 3px 4px 7px 0px #a5a5a540;
    }
  }
  .title {
    padding-top: 0.8rem;
    padding-bottom: 1rem;
    font-weight: 500;
    font-size: 1.6rem;
    color: #000;
    margin: auto;
    text-overflow: ellipsis;
  }
}
</style>
